import { NavLink } from 'react-router-dom';
import {
  FiX,
  FiHome,
  FiLayout,
  FiFileText,
  FiBookOpen,
  FiInbox,
  FiMail,
  FiSend,
  FiUsers,
  FiServer,
  FiGrid,
  FiEdit3,
  FiImage,
} from 'react-icons/fi';
import logo from '../../assets/logos/Logo.svg';
import { MARKET_ANALYSIS_POST_PAGES_PATH } from '../../utils/pageGroups';

const navItems = [
  { label: 'Overview', to: '/dashboard', end: true, icon: FiHome },
  { label: 'Global Layout', to: '/dashboard/global-layout', icon: FiLayout },
  { label: 'Pages', to: '/dashboard/pages', end: true, icon: FiFileText },
  { label: 'Market Analysis Posts', to: MARKET_ANALYSIS_POST_PAGES_PATH, icon: FiBookOpen },
  { label: 'Account Submissions', to: '/dashboard/account-submissions', icon: FiInbox },
  { label: 'Contact Submissions', to: '/dashboard/contact-submissions', icon: FiMail },
  { label: 'Newsletter Subscriptions', to: '/dashboard/newsletter-subscriptions', icon: FiSend },
  { label: 'Partnership Submissions', to: '/dashboard/partnership-submissions', icon: FiUsers },
  { label: 'VPS Hosting Requests', to: '/dashboard/vps-hosting-requests', icon: FiServer },
  { label: 'Sections', to: '/dashboard/sections', soon: true, icon: FiGrid },
  { label: 'Content', to: '/dashboard/content', soon: true, icon: FiEdit3 },
  { label: 'Media', to: '/dashboard/media', soon: true, icon: FiImage },
];

const Sidebar = ({ isOpen, onClose }) => {
  return (
    <>
      <div
        className={`fixed inset-0 z-40 bg-[#130705]/35 transition-opacity lg:hidden ${
          isOpen ? 'opacity-100' : 'pointer-events-none opacity-0'
        }`}
        onClick={onClose}
        aria-hidden
      />

      <aside
        className={`fixed inset-y-0 left-0 z-50 flex w-60 flex-col border-r border-[#e4d9c8] bg-white transition-transform duration-200 lg:static lg:translate-x-0 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex h-14 items-center justify-between border-b border-[#e4d9c8] px-5">
          <div className="flex items-center gap-2.5">
            <img src={logo} alt="VBS Invest" className="h-6" />
            <div className="leading-none">
              <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[#8d7045]">
                CMS
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="!bg-transparent !p-1.5 !text-[#6b635c] !shadow-none hover:!bg-transparent hover:!shadow-none lg:hidden"
            aria-label="Close menu"
          >
            <FiX className="h-4 w-4" />
          </button>
        </div>

        <nav className="flex-1 px-3 py-5">
          <p className="mb-2 px-2 text-[11px] font-medium uppercase tracking-[0.14em] text-[#a8a098]">
            Menu
          </p>
          <ul className="space-y-0.5">
            {navItems.map((item) => {
              const Icon = item.icon;

              if (item.soon) {
                return (
                  <li key={item.label}>
                    <div
                      className="flex items-center justify-between rounded-md px-3 py-2 text-[13px] text-[#b0a89f]"
                      title="Coming soon"
                    >
                      <span className="flex items-center gap-2.5">
                        {Icon ? <Icon className="h-4 w-4 shrink-0 opacity-70" /> : null}
                        {item.label}
                      </span>
                      <span className="text-[10px] font-medium uppercase tracking-wide text-[#c9b48a]">
                        Soon
                      </span>
                    </div>
                  </li>
                );
              }

              return (
                <li key={item.label}>
                  <NavLink
                    to={item.to}
                    end={item.end}
                    onClick={onClose}
                    className={({ isActive }) =>
                      `flex items-center gap-2.5 rounded-md px-3 py-2 text-[13px] transition ${
                        isActive
                          ? 'bg-[#f5f1ea] font-medium text-[#785E32]'
                          : 'text-[#4a4340] hover:bg-[#faf8f4] hover:text-[#130705]'
                      }`
                    }
                  >
                    {Icon ? <Icon className="h-4 w-4 shrink-0" /> : null}
                    {item.label}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>

        <div className="border-t border-[#e4d9c8] px-4 py-4">
          <div className="rounded-md border border-[#e4d9c8] bg-[#faf8f4] px-3.5 py-3">
            <p className="text-[12px] font-medium text-[#130705]">VBS CMS</p>
            <p className="mt-0.5 text-[12px] leading-relaxed text-[#8a8178]">
              Admin workspace for site content.
            </p>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
